export default "__VITE_ASSET__deI3ey2t__"